var React = require('react');

function Wrench (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.7499 6.39247C29.6186 5.86337 28.9565 5.68408 28.571 6.06962L24.2139 10.4266L20.2366 9.76395L19.5739 5.78662L23.9309 1.4296C24.3188 1.04171 24.1319 0.380772 23.5993 0.24835C20.8231 -0.439539 17.7663 0.30167 15.5966 2.4708C13.2739 4.79345 12.6347 8.16024 13.6015 11.0958L1.09819 23.5991C-0.366063 25.0633 -0.366063 27.4375 1.09819 28.9018C2.56244 30.366 4.93666 30.366 6.40091 28.9018L18.8937 16.409C21.8304 17.3881 25.1907 16.7419 27.5286 14.404C29.7007 12.2319 30.4407 9.1704 29.7499 6.39247ZM3.75014 27.6561C2.97377 27.6561 2.34389 27.0262 2.34389 26.2498C2.34389 25.4729 2.97377 24.8436 3.75014 24.8436C4.5265 24.8436 5.15638 25.4729 5.15638 26.2498C5.15638 27.0262 4.5265 27.6561 3.75014 27.6561Z"}));
}

Wrench.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Wrench;

Wrench.default = Wrench;
